import { css } from '@emotion/react';
import { Header } from 'screens/booker/components/Header';
import { Heading } from 'screens/booker/components/Heading';
import { Link } from 'react-router-dom';
import { routes } from 'routes';
import { ArtistForm } from './forms/ArtistForm';
import { theme } from 'styles/theme';

export const ScreenCreateArtist = () => {
	return (
		<div>
			<Header>
				<Heading
					left={
						<div>
							<h1
								css={css`
									font-size: 24px;
									line-height: 36px;
									font-weight: normal;
									margin-bottom: 0;

									display: flex;
									align-items: center;
									gap: 12px;
								`}
							>
								{/* <Link to={routes.booker.artist}>{'<-'}</Link> Interpreti / Přidat interpreta */}
								<Link
									to={routes.booker.artist}
									css={css`
										color: ${theme.color.text[300]};

										&:hover {
											text-decoration: none;
										}
									`}
								>
									Interpreti
								</Link>{' '}
								<span
									css={css`
										color: ${theme.color.text[300]};
									`}
								>
									-&gt;
								</span>{' '}
								Přidat interpreta
							</h1>
						</div>
					}
				></Heading>
			</Header>

			<div
				css={css`
					display: flex;
					padding: 32px;
					width: 580px;
					flex-direction: column;
				`}
			>
				<ArtistForm />
			</div>
		</div>
	);
};
